import { faClipboard } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback } from "react";

import { Button, Text, toast } from "@skydio/rivet-ui";

export interface ResultRowProps {
  label: string;
  value: string;
}

export const ResultRow = ({ label, value }: ResultRowProps) => {
  const handleClick = useCallback(async () => {
    await navigator.clipboard.writeText(value);
    toast.success(label + " copied to clipboard", { duration: 3000 });
  }, [label, value]);

  return (
    <>
      <Text className="col-span-2 h-full self-center justify-self-stretch">{label}: </Text>
      <span className="col-span-10 h-full justify-self-stretch">
        <span className="align-center flex h-full justify-stretch">
          <Text className="inline-block h-full min-w-[32rem] max-w-md justify-self-stretch overflow-hidden truncate whitespace-nowrap border border-solid bg-gray-50 px-2 text-gray-700">
            {value}
          </Text>
          <Button variant="link" size="sm" className="py-0" isIconOnly onClick={handleClick}>
            <FontAwesomeIcon icon={faClipboard} />
          </Button>
        </span>
      </span>
    </>
  );
};
